<div class="__item"
     (click)="selectItem(ListPaneType.Grid)"
     (mouseover)="onHoverItem(ListPaneType.Grid)"
     (mouseout)="onMouseoutItem(ListPaneType.Grid)">
  <awair-grid-icon class="__item-icon"
                   [color]="gridColor">
  </awair-grid-icon>
  <span class="__item-name"
        [style.color]="gridColor">
    Grid
  </span>
</div>

<div class="__divider"></div>

<div class="__item"
     (click)="selectItem(ListPaneType.Floor)"
     (mouseover)="onHoverItem(ListPaneType.Floor)"
     (mouseout)="onMouseoutItem(ListPaneType.Floor)">
  <awair-floor-icon class="__item-icon"
                    [color]="floorColor">
  </awair-floor-icon>
  <span class="__item-name"
        [style.color]="floorColor">
    Floor
  </span>
</div>
